export default "__VITE_ASSET__CqVYFnwM__"